<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <Form ref="form" :model="formData" :rules="rule" :label-width="120">
                <Row>
                    <Col span="12">
                        <FormItem  :label="$t('org_cname')" prop="user_code">
                            <Input v-model="org_cname" disabled></Input>
                        </FormItem>
                    </Col>
                </Row>
                <FormItem :label="$t('select_role')">
                    <CheckboxGroup v-model="formData.cats">
                        <Checkbox v-for="(item, index) in cats" :key="index" :label="JSON.stringify(item)">{{item.value}}</Checkbox>
                    </CheckboxGroup>
                </FormItem>
            </Form>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" @click="addRole">{{$t('add_role')}}</Button>
            <Button type="error" @click="addAllRole" v-if="$base.getOrgId() != formData.org_id">{{$t('addrole')}}</Button>
        </div>
    </div>
</template>

<script>
    export default {
        data:function(){
            return{
                relist:false,
                org_levels:[],
                formData: {
                    org_id: '',
                    cats: [],
                },
                cats: [],
                org_cname : '',
                rule: {}
            }
        },
        computed:{
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.org_cname = this.$base.getRequest().org_cname;
            this.formData.org_id = this.$base.getRequest().org_id;
            this.getLoad();
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            getLoad: function(){
                const org_id = this.formData.org_id;
                this.$base.showLoading();
                this.$request.sendPost("down-role-s1/before-add",{org_id},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.cats = data.cats;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            setRole: function (url) {
                this.formData.cats = this.formData.cats.map(item => JSON.parse(item));
                this.$base.showLoading();
                this.$request.sendPost(url,this.formData,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.$base.msgSuccess(error.errmsg);
                        this.relist = true;
                        this.$base.linkBack();
                    }
                    else{
                        this.$base.msgErr(error.errmsg);
                    }
                });
            },
            addRole: function () {
                this.setRole('down-role-s1/add')
            },
            addAllRole: function () {
                let content = this.$t('confirm_addrole');
                let title =  this.$t('tips');
                this.$base.confirm(title,content, () => {
                    this.setRole('down-role-s1/add-all')
                },()=>{})
           },
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/downrole/downroles1_add.vue